<sk-select
  [label]="label() | translate"
  [items]="entities()"
  [searchable]="true"
  class="sk-select-inline d-flex"
  bindLabel="name"
  bindValue="name"
  appendTo="body"
  [formControl]="fieldControl"
></sk-select>
